module.exports = __webpack_public_path__ + "media/images/subscription-promo-mobile-no-shadow-c5292ff8094fb3d34581b2f112151798.png";